"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ChevronDoubleDownIcon = function ChevronDoubleDownIcon(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 256.045 256.006"
  }, props), _react.default.createElement("g", {
    "data-name": "Arrow (Double Up Chevron)"
  }, _react.default.createElement("g", {
    "data-name": "Group 665"
  }, _react.default.createElement("path", {
    "data-name": "Path 754",
    d: "M3.773 140.673l116 112a12 12 0 0016.6 0l116-112a12.023 12.023 0 10-16.7-17.3l-107.6 104-107.7-103.9a12.023 12.023 0 10-16.7 17.3z"
  }), _react.default.createElement("path", {
    "data-name": "Path 755",
    d: "M3.773 20.673l116 112a12 12 0 0016.6 0l116-112a12.023 12.023 0 10-16.7-17.3l-107.6 104-107.7-103.9a12.023 12.023 0 10-16.7 17.3z"
  }))));
};

ChevronDoubleDownIcon.propTypes = {
  size: _propTypes.number
};
ChevronDoubleDownIcon.defaultProps = {
  size: 40
};
var _default = ChevronDoubleDownIcon;
exports.default = _default;